import { PresetGroupDetailsField } from './preset-group-details-field.model';

export class PresetGroupDetails {
  userId: string;
  groupId: number | string;
  id: string | number;
  displayName: string;
  fieldDetails: PresetGroupDetailsField[];
}
